import * as types from "./types";

const mutations = {
  [types.CHANGE_LANGUAGE](state, payload) {
    state.currentLanguage = payload;
  },
  [types.SET_LANGUAGE](state, payload) {
    state.languages = payload;
  },
  [types.SET_BFORCED](state, payload) {
    state.bForced = payload;
  }
};

export default mutations;
